/* ============================================================
   Masaüstü menü: 3. seviye panelin akıllı konumu
   - Normalde panel, üzerine gelinen satırın hizasında açılır
     (fare yatay gidip panele ulaşır).
   - Panel ekranın altına taşacaksa SADECE gerektiği kadar
     yukarı kaydırılır.
   - En fazla ana panelin tepesine kadar çıkar, daha yukarı değil.
   ============================================================ */
(function () {
  'use strict';

  var ALT_PAY = 10; // ekranın altından bırakılacak boşluk (px)
  var SEC_LI = '.wt-page-nav-mega__sublist--parent';
  var SEC_PANEL = '.wt-page-nav-mega__sublist--nested';
  var SEC_KAPSAYICI = '.wt-page-nav-mega__sublist__wrapper';

  function hizala(li) {
    var panel = li.querySelector(SEC_PANEL);
    if (!panel) return;

    var satir = li.getBoundingClientRect();
    var yuk = panel.scrollHeight; // kapalıyken de gerçek içerik yüksekliği
    if (!yuk) return;

    var tasma = satir.top + yuk + ALT_PAY - window.innerHeight;
    var ust = tasma > 0 ? -Math.ceil(tasma) : 0;

    // ana panelin tepesinden yukarı çıkma
    var kapsayici = li.closest(SEC_KAPSAYICI);
    if (kapsayici) {
      var sinir = Math.round(kapsayici.getBoundingClientRect().top - satir.top);
      if (ust < sinir) ust = sinir;
    }

    // FARE GEÇİŞİ ÖNCELİKLİ: panelin alt kenarı, üzerine gelinen satırın
    // alt kenarından yukarı çıkmasın — yoksa fare yatay giderken panele
    // giremez. Bu kural en sonda, yani gerekirse alt payı feda eder.
    var altSinir = Math.min(satir.height, yuk) - yuk;
    if (ust < altSinir) ust = altSinir;

    panel.style.top = Math.round(ust) + 'px';
  }

  function tetik(e) {
    if (window.innerWidth < 1200) return;
    var hedef = e.target;
    if (!hedef || !hedef.closest) return;
    var li = hedef.closest(SEC_LI);
    if (li) hizala(li);
  }

  document.addEventListener('mouseover', tetik, true);
  document.addEventListener('focusin', tetik, true);
})();
